module.exports = __webpack_public_path__ + "media/images/number_6_red-a13563702268f138565c8ac30757b3fd.png";